import { useSiteInfo } from '@contexts/SiteInfoContext';
import SiteMapping from '@configs/siteMapping';
import useScrollToTop from '../../hooks/useScrollToTop';

const GoToTopButton = () => {
    const { siteName } = useSiteInfo();
    const { isVisible, scrollToTop } = useScrollToTop();

    const buttonClassname = {
        [SiteMapping.viva88]: 'btn btn--icon btn--gototop',
        [SiteMapping.bong88]: 'btn btn--icon btn--gototop',
        [SiteMapping.Nova88]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.PICA88]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.IBCBet]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.id8899]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.bettha88]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.taraPlays]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.fifabet]: 'btn btn--primary btn--icon btn--gototop',
        [SiteMapping.ocean99]: 'btn btn--primary btn--icon btn--gototop',
    }[siteName];

    return (
        <a
            className={buttonClassname}
            data-open={isVisible}
            role="mobile-visible"
            onClick={scrollToTop}
        >
            <i className="icon icon--gototop" />
        </a>
    );
};

export default GoToTopButton;
